// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"abfd03ba","681":"d4f8b27a","710":"d7336252","787":"2bddaa12"}[chunkId] + ".chunk.js";
};